const productNodesQuery = {
        collection: 'node',
        query: {
            bundle: 'product',
        },
        sort: {order: 1},
        projection: {type: 1, bundle: 1, title: 1, path: 1, img: 1, parent:1, _i18n: 1}
}
export {productNodesQuery}